export default __webpack_public_path__ + "static/media/WM0360.34I-43133_-25798_0.08ecfc26.jpg";